/**
 * Mete solo en el carrito el producto de regalo cuando el pedido lo merece.
 *
 * POR QUE HACE FALTA ESTO: el descuento automatico BXGY deja el regalo a 0 EUR, pero NO lo
 * añade. La documentacion de Shopify es literal: "Customers must add all items to their cart
 * manually. The free or discounted 'get' item is never automatically added to the cart". Sin
 * este fichero, quien gasta 30 EUR no se entera de que tiene un regalo.
 *
 * LA REGLA DE ORO DE ESTE FICHERO: NO DA POR HECHO QUE EL REGALO SALGA GRATIS. Lo añade, vuelve
 * a leer el carrito y comprueba que Shopify le ha aplicado un descuento que cubre TODO su
 * precio. Si no lo cubre, lo quita. Esa comprobacion no es paranoia: hay al menos tres formas
 * de que el descuento no entre y ninguna avisa.
 *
 *   1. La condicion de compra puede no cumplirse. Y OJO, que esto costo un fallo real: Shopify
 *      NO cuenta la linea del regalo para esa condicion. Con un minimo en euros, un carrito por
 *      debajo deja el regalo sin descuento; y los 25 productos sin etiqueta `cat:` (reports/31)
 *      no cuentan nunca. Cobrarle 15,99 EUR a alguien por un "regalo" es peor que no ofrecerlo.
 *   2. Si el regalo se queda sin stock, Shopify lo marca agotado y el descuento deja de
 *      aplicarse.
 *   3. Si alguien cambia o desactiva la promocion, esto se apaga solo en vez de seguir metiendo
 *      un producto de pago en el carrito de todo el mundo.
 *
 * Y RESPETA AL COMPRADOR: si quita el regalo a mano, no se le vuelve a meter en toda la sesion.
 * Un producto que reaparece cuando lo borras no es un regalo, es una trampa.
 *
 * PERO "NO LO QUIERO" Y "TODAVIA NO TOCA" SON COSAS DISTINTAS, y confundirlas fue un fallo real
 * del 2026-08-21: cualquier carrito que no diera derecho al regalo marcaba la sesion como
 * rechazada, igual que si el comprador lo hubiera borrado, y ya no volvia aunque siguiera
 * comprando. Sintoma: "aparece una vez y luego desaparece". Ahora el "no da derecho" se apunta
 * con el subtotal que fallo y se reintenta en cuanto el carrito crece.
 */
(function () {
  'use strict';

  var cfg = document.getElementById('wh-regalo-carrito');
  if (!cfg) return;

  var VARIANTE = parseInt(cfg.dataset.variante, 10);
  var CLAVE_RECHAZO = 'wh:regalo-rechazado'; // el COMPRADOR lo quito: no se insiste mas
  var CLAVE_PUESTO = 'wh:regalo-puesto'; // lo pusimos nosotros y seguia ahi
  var CLAVE_SIN_DERECHO = 'wh:regalo-sin-derecho'; // subtotal con el que NO dio derecho
  if (!VARIANTE) return;

  var trabajando = false;

  function carrito() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.ok ? r.json() : null;
    });
  }

  function lineaDelRegalo(datos) {
    for (var i = 0; i < datos.items.length; i++) {
      if (datos.items[i].variant_id === VARIANTE) return datos.items[i];
    }
    return null;
  }

  /** Lo que suma el carrito SIN contar el regalo, en centimos. */
  function subtotalSinRegalo(datos) {
    var total = 0;
    for (var i = 0; i < datos.items.length; i++) {
      if (datos.items[i].variant_id !== VARIANTE) total += datos.items[i].final_line_price;
    }
    return total;
  }

  function hayOtroProducto(datos) {
    for (var i = 0; i < datos.items.length; i++) {
      if (datos.items[i].variant_id !== VARIANTE) return true;
    }
    return false;
  }

  /** Suma de los descuentos aplicados a una linea, en centimos. */
  function descuentoDe(linea) {
    var total = 0;
    var asignaciones = linea.line_level_discount_allocations || linea.discounts || [];
    for (var i = 0; i < asignaciones.length; i++) {
      total += asignaciones[i].amount || 0;
    }
    return total;
  }

  function anadir() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: VARIANTE, quantity: 1 }] })
    });
  }

  function quitar(clave) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: clave, quantity: 0 })
    });
  }

  function refrescar() {
    // El tema repinta el carrito con sus propios eventos. Si estamos EN la pagina del carrito
    // no basta, porque el HTML ya esta servido: ahi si toca recargar, y una sola vez.
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    if (window.location.pathname.indexOf('/cart') === 0) window.location.reload();
  }

  function revisar() {
    if (trabajando) return;
    trabajando = true;

    carrito()
      .then(function (datos) {
        if (!datos) return;

        // UN CARRITO VACIO ES EMPEZAR DE CERO. Lo que se decidio sobre un carrito que ya no
        // existe no puede seguir pesando sobre el siguiente, asi que aqui se olvidan las tres
        // marcas de la sesion.
        //
        // Esto arregla un fallo REAL: el regalo se pinta como PRIMERA linea del carrito, asi
        // que quien lo vacia de arriba abajo lo borra a el primero. La marca "lo pusimos
        // nosotros" sobrevivia al vaciado y, en la compra siguiente, el codigo veia "no esta el
        // regalo y si hay productos" y concluia que el comprador lo habia rechazado. Sintoma:
        // con la sesion recien abierta funciona, y si vacias el carrito y vuelves a comprar ya
        // no aparece nunca.
        //
        // VA ANTES DE MIRAR EL RECHAZO, y es la parte que importa: si se comprobara despues, la
        // sesion ya marcada saldria por la puerta de arriba y no llegaria a ver nunca que el
        // carrito se habia vaciado.
        if (!datos.items.length) {
          sessionStorage.removeItem(CLAVE_RECHAZO);
          sessionStorage.removeItem(CLAVE_PUESTO);
          sessionStorage.removeItem(CLAVE_SIN_DERECHO);
          return null;
        }

        if (sessionStorage.getItem(CLAVE_RECHAZO) === '1') return null;

        var regalo = lineaDelRegalo(datos);
        var acompanado = hayOtroProducto(datos);

        // Carrito sin nada mas: el regalo no pinta nada ahi.
        if (regalo && !acompanado) {
          sessionStorage.removeItem(CLAVE_PUESTO);
          return quitar(regalo.key).then(refrescar);
        }
        if (regalo) sessionStorage.setItem(CLAVE_PUESTO, '1');

        // SE DEDUCE DEL CARRITO Y NO DEL CLIC, y esto es una correccion: la primera version
        // escuchaba clics en `a[href*="/cart/change"]` y `.cart-remove-button`, selectores que
        // en ESTE tema no existen -usa `.wt-cart__item__remove` con `href="#"`-, asi que el
        // regalo reaparecia al borrarlo. Un producto que vuelve cuando lo quitas no es un
        // regalo, es una trampa. Mirar el estado del carrito no depende de como se llame el
        // boton, asi que no se rompe si el tema cambia.
        if (!regalo && acompanado && sessionStorage.getItem(CLAVE_PUESTO) === '1') {
          sessionStorage.setItem(CLAVE_RECHAZO, '1');
          sessionStorage.removeItem(CLAVE_PUESTO);
          return null;
        }

        // NO SE REINTENTA CON UN CARRITO QUE YA FALLO, pero SI en cuanto crece. Es la
        // correccion del fallo de "aparece una vez y luego desaparece": antes, cualquier
        // carrito que no diera derecho al regalo marcaba la sesion como RECHAZADA, igual que
        // si el comprador lo hubiera quitado, y ya no volvia nunca. Son dos cosas distintas:
        // "todavia no toca" es temporal y "no lo quiero" es del comprador.
        var subtotal = subtotalSinRegalo(datos);
        var fallo = parseInt(sessionStorage.getItem(CLAVE_SIN_DERECHO) || '-1', 10);
        if (!regalo && acompanado && subtotal <= fallo) return null;

        if (!regalo && acompanado) {
          return anadir()
            .then(carrito)
            .then(function (despues) {
              if (!despues) return;
              var puesto = lineaDelRegalo(despues);
              if (!puesto) return;
              // LA COMPROBACION QUE JUSTIFICA EL FICHERO: si el descuento no cubre todo su
              // precio, no es un regalo y se retira. Pasa de verdad, y no es raro: Shopify NO
              // cuenta la linea del regalo para la condicion de compra, asi que un carrito por
              // debajo del minimo -o hecho solo con los 25 productos sin categoria- lo deja sin
              // descuento. Tambien cubre que se agote el stock o que alguien pare la promocion.
              if (descuentoDe(puesto) < puesto.final_line_price) {
                sessionStorage.setItem(CLAVE_SIN_DERECHO, String(subtotal));
                sessionStorage.removeItem(CLAVE_PUESTO);
                return quitar(puesto.key).then(refrescar);
              }
              sessionStorage.removeItem(CLAVE_SIN_DERECHO);
              sessionStorage.setItem(CLAVE_PUESTO, '1');
              refrescar();
            });
        }
        return null;
      })
      .catch(function () {
        // Un fallo de red no puede dejar el carrito a medias ni romper la pagina.
      })
      .then(function () {
        trabajando = false;
      });
  }

  document.addEventListener('DOMContentLoaded', revisar);
  document.addEventListener('cart:updated', revisar);
  document.addEventListener('cart:change', revisar);
  if (document.readyState !== 'loading') revisar();
})();
